import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import css from "./index.module.css";
import Content from "@components/adminNavigation";
import axios from "axios";
import * as Types from "../../../types";
import SEO from "@components/seo";

export default function AdmOrganizations() {
  const navigate = useNavigate();
  const [organizations, setOrganizations] = useState<Types.Organization[]>([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_ADM_URL}/organizations`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setOrganizations(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleSubmit = (event: any) => {
    event.preventDefault();

    axios
      .get(`${import.meta.env.VITE_API_ADM_URL}/organizations?query=${query}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setOrganizations(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Content>
      <SEO
        title={"Управление организациями"}
        description={"Админ-панель"}
        ogUrl={`https://рыбныимир.рф/`}
      />

      <h1 className={css.head}>Организации</h1>

      <form className={css.search} onSubmit={handleSubmit}>
        <input
          placeholder="Поиск (по названию, ИНН или ОГРН)"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit">
          <i className="fi fi-rr-search" />
        </button>
      </form>

      <div className={css.table}>
        <div className={css.tableHeader}>
          <a>Название</a>
          <a>Адрес</a>
          <a>ИНН</a>
          <a>ОГРН</a>
          <a>Статус</a>
        </div>

        <div className={css.tableBody}>
          {organizations.map((item) => (
            <div
              className={css.tableDiv}
              onClick={() => navigate(`/manage/organization/${item.id}`)}
            >
              <a>{item.name}</a>
              <a>{item.address || "Не указано"}</a>
              <a>{item.inn || "Не указано"}</a>
              <a>{item.ogrn || "Не указано"}</a>
              <a>{(item.status === "ACTIVE" && !item.isDeleted) ? <span style={{ color: 'green' }}>Действующая</span> : item.isDeleted ? <span style={{ color: 'red' }}>Удалена</span> : <span style={{ color: 'red' }}>Ликвидирована</span>}</a>
            </div>
          ))}
        </div>
      </div>
    </Content>
  );
}
